import WpLogin from "../../../theetheme-v8/src/js/base/WpLogin";

new WpLogin();